import type {
  Attachment,
  FineUploaderUpload,
} from './api'

const byteSizeLabels = ['B', 'KiB', 'MiB', 'GiB', 'TiB'] as const
const hiddenUploadStatuses = ['deleted', 'deleting', 'canceled', 'rejected']
const inactiveUploadStatuses = [...hiddenUploadStatuses, 'delete failed', 'upload failed']

export function formatBytes(size: number): string {
  if (size <= 0) return '0 B'

  const base = Math.log(size) / Math.log(1024)
  const suffix = byteSizeLabels[Math.floor(base)]

  return `${Math.round(Math.pow(1024, base - Math.floor(base)))} ${suffix}`
}

export function tooManyUploadItemsMessage(netItems: number, itemLimit: number): string {
  return `Too many items (${netItems}) would be uploaded.  Item limit is ${itemLimit}.`
}

export function visibleNewUploads(attachments: FineUploaderUpload[]): FineUploaderUpload[] {
  return attachments.filter((attachment) => {
    return !hiddenUploadStatuses.includes(attachment.status)
  })
}

export function activeNewUploadCount(attachments: FineUploaderUpload[]): number {
  return attachments.filter((attachment) => {
    return !inactiveUploadStatuses.includes(attachment.status)
  }).length
}

export function activeSavedAttachmentCount(
  attachments: Attachment[],
  deletedAttachmentIds: number[],
): number {
  return attachments.filter((attachment) => {
    return !deletedAttachmentIds.includes(attachment.attachment_id)
  }).length
}

export function uploadItemLimit(activeSavedAttachments: number, maxAttachments: number): number {
  return Math.max(0, maxAttachments - activeSavedAttachments)
}

export function activeAttachmentCount(activeSavedAttachments: number, activeNewUploads: number): number {
  return activeSavedAttachments + activeNewUploads
}

export function canUploadAttachment(activeAttachments: number, maxAttachments: number): boolean {
  return activeAttachments < maxAttachments
}

export function showFineUploader(canUpload: boolean, visibleNewUploadCount: number): boolean {
  return canUpload || visibleNewUploadCount > 0
}

export function uploadStatusText(attachment: FineUploaderUpload): string {
  if (attachment.status === 'upload failed') return 'Upload failed'
  if (attachment.status === 'uploading') return 'Uploading'
  if (attachment.status === 'retrying upload') return 'Retrying'
  if (attachment.status === 'deleting') return 'Deleting'
  if (attachment.status === 'delete failed') return 'Delete failed'
  return ''
}

export function uploadStatusClass(attachment: FineUploaderUpload): Record<string, boolean> {
  return {
    'qq-in-progress': attachment.status === 'uploading',
    'qq-upload-retrying': attachment.status === 'retrying upload',
    'qq-upload-success': attachment.status === 'upload successful',
    'qq-upload-fail': attachment.status === 'upload failed',
  }
}
